import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from 'translations/en.json'
import az from 'translations/az.json'

i18next.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    az: {
      translation: az,
    },
  },
  lng: 'az',
  fallbackLng: 'az',
})

i18next.on('change', (lang) => {
  document.documentElement.lang = lang
})

export default i18next
